import React from "react";
import * as S from "./InputFeild.styles";

interface IInputField {
  inputType?: string;
  labelText?: string;
  subLabelText?: string;
  placeholderText?: string;
  defaulText?: string;
  inputWidth?: string;
  inputHeight?: string;
  margin?: string;
  padding?: string;
  onChange?: Function;
  onBlur?: Function;
  value?: string;
  reference?: string;
  styledProps: object;
  autoCompleteProp?: string;
}


const InputField: React.FC<IInputField> = ({
  inputType,
  labelText,
  subLabelText,
  placeholderText,
  defaulText,
  inputWidth,
  inputHeight,
  margin,
  padding,
  onChange,
  onBlur,
  value,
  reference,
  styledProps =  {},
  autoCompleteProp = "on"
}) => {
  return (
    <S.FieldCont
      inputWidth={inputWidth}
      inputHeight={inputHeight}
      margin={margin}
      padding={padding}
    >
      {(labelText || subLabelText) && (
        <div className="labelCont">
          {labelText && <label className="lblText">{labelText}</label>}
          {subLabelText && <span className="lblSubText">{subLabelText}</span>}
        </div>
      )}
      <input
        ref={reference}
        className="textInput"
        type={inputType ? inputType : "text"}
        onChange={onChange ? onChange : null}
        defaultValue={defaulText ? defaulText : ""}
        placeholder={placeholderText ? placeholderText : ""}
        onBlur={onBlur ? onBlur : null}
        value={value}
        style={styledProps}
        autocomplete={autoCompleteProp}
      />
    </S.FieldCont>
  );
};

export default InputField;
